import React, { useState, useEffect } from 'react';
import { Container, Form, InputGroup, Button, NavLink } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const HomeComp = () => {
    const navigate = useNavigate();

    const [products, setProducts] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);

    const getProducts = async (val) => {
        setLoading(true);
        const params = val ? `/search?q=${val}` : '';
        const response = await fetch(`https://dummyjson.com/products${params}`);
        const respJson = await response.json();
        setProducts(respJson.products);
        setLoading(false);
    };

    const handleSearch = (e) => {
        const { target } = e;
        setSearch(target.value);
        getProducts(search);
    };

    const handleSubmit = () => {
        getProducts(search);
    };

    const getListProducts = () => {
        return <>{getProductList()}</>;
    };

    const getProductList = () => {
        if (loading) {
            return <p>Loading...</p>;
        } else if (!loading && products.length === 0) {
            return <p>Products is empty</p>;
        } else {
            return products.map((val, i) => {
                return (
                    <NavLink className="productWrapper" onClick={() => navigate(`/products/${val.id}`)} key={i}>
                        <img src={val.thumbnail} alt={val.title} />

                        <div className="productDesc">
                            <div className="mt-2">
                                <p className="fw-bold">${val.price}</p>
                                <p>{val.title.slice(0, 25)}</p>
                            </div>
                        </div>
                    </NavLink>
                );
            });
        }
    };

    useEffect(() => {
        getProducts();
    }, []);

    return (
        <>
            <div>
                <section>
                    <Container>
                        <div className="tagHeader">
                            <h1>PRODUCT LIST</h1>
                        </div>

                        <div className="formContainer">
                            <InputGroup className="mb-3">
                                <Form.Control placeholder="Search Product" aria-describedby="basic-addon2" onChange={handleSearch} />
                                <Button variant="secondary" id="button-addon2" onClick={handleSubmit}>
                                    Search
                                </Button>
                            </InputGroup>
                        </div>

                        <div className="productContainer">{getListProducts()}</div>
                    </Container>
                </section>
            </div>
        </>
    );
};

export default HomeComp;
